import React, {createContext, useContext, useMemo} from "react";
import {IndexedDbLotoCardboardRepository} from "../../tickets/infrastructure/repositories/IndexedDbLotoCardboardRepository";
import {AddLotoCardboard} from "../../tickets/application/usecases/AddLotoCardboard";
import {UpdateLotoCardboard} from "../../tickets/application/usecases/UpdateLotoCardboard";
import {DeleteLotoCardboard} from "../../tickets/application/usecases/DeleteLotoCardboard";
import {DeleteAllLotoCardboards} from "../../tickets/application/usecases/DeleteAllLotoCardboards";
import {ListLotoCardboards} from "../../tickets/application/usecases/ListLotoCardboards";
import {LotoCardboardRepository} from "../../tickets/application/ports/LotoCardboardRepository";

export type AppContainer = {
    lotoCardboards: {
        repo: LotoCardboardRepository;
        usecases: {
            add: AddLotoCardboard;
            update: UpdateLotoCardboard;
            remove: DeleteLotoCardboard;
            removeAll: DeleteAllLotoCardboards;
            list: ListLotoCardboards;
        };
    };
};

const AppContainerContext = createContext<AppContainer | null>(null);

export const AppContainerProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const value = useMemo<AppContainer>(() => {
        const lotoCardboardRepo = new IndexedDbLotoCardboardRepository();
        return {
            lotoCardboards: {
                repo: lotoCardboardRepo,
                usecases: {
                    add: new AddLotoCardboard(lotoCardboardRepo),
                    update: new UpdateLotoCardboard(lotoCardboardRepo),
                    remove: new DeleteLotoCardboard(lotoCardboardRepo),
                    removeAll: new DeleteAllLotoCardboards(lotoCardboardRepo),
                    list: new ListLotoCardboards(lotoCardboardRepo),
                },
            },
        };
    }, []);

    return <AppContainerContext.Provider value={value}>{children}</AppContainerContext.Provider>;
};

export const useAppContainer = () => {
    const ctx = useContext(AppContainerContext);
    if (!ctx) throw new Error("AppContainerProvider is missing");
    return ctx;
};
